export const DayOneData = [
  {
    id: 1,
    speaker: "Sudhanshu Yadav",
    title: "Destructuring React",
    slidesURL:
      "https://drive.google.com/file/d/1pEH5CwMWX55bjUFDh9c7Pqp_WUGQ1UCd/view",
    ytURL: "https://www.youtube.com/watch?v=zmO51Dn5DPI",
  },
  {
    id: 2,
    speaker: "Ankita Masand",
    title: "Event Delegation in React 17",
    slidesURL: "https://slides.com/ankitamasand06/event-delegation-in-react-17",
    ytURL: "https://www.youtube.com/watch?v=16VS048MsfQ",
  },
  {
    id: 3,
    speaker: "Dane David",
    title: "Failing Gracefully: Error Boundaries in React",
    slidesURL:
      "https://drive.google.com/file/d/1e2DXRNBYwRHGPJG0KQWK1DU8neZLXSqm/view",
    ytURL: "https://www.youtube.com/watch?v=t5TfkIKUJE4",
  },
  {
    id: 4,
    speaker: "Nikhil Sharma",
    title: "Road to a better UX with Suspense and Concurrent UI",
    slidesURL:
      "https://docs.google.com/presentation/d/19uCb_55Hx2ubaYmJIeg6jHxvsLiyBNYsNrCwxXddB9A/edit#slide=id.p",
    ytURL: "https://www.youtube.com/watch?v=DyLeCgP3UQo",
  },
  {
    id: 5,
    speaker: "Nitish Phanse",
    title: "Thinking of UI as a State Machine",
    slidesURL: "",
    ytURL: "https://www.youtube.com/watch?v=rt2YaJqXynE",
  },
  {
    id: 6,
    speaker: "Dipti Roy",
    title: "Machina and its use case with Server Driven UI",
    slidesURL:
      "https://www.slideshare.net/DiptiRoy2/finite-state-machine-for-server-driven-ui",
    ytURL: "https://www.youtube.com/watch?v=5x52jsDS1s8",
  },
  {
    id: 7,
    speaker: "Thiyagaraj T",
    title: "Untangling reducers into reusable patterns",
    slidesURL: "",
    ytURL: "https://www.youtube.com/watch?v=fJWrqCZZlsg",
  },
  {
    id: 8,
    speaker: "Anshuman Verma",
    title: "Virtualization in React",
    slidesURL: "https://slides.com/anshumanv/deck-b0bc4c",
    ytURL: "https://www.youtube.com/watch?v=11wGOsWVhKg",
  },
  {
    id: 9,
    speaker: "Siddharth Kshetrapal",
    title: "Building smooth interactive interfaces with React",
    slidesURL: "",
    ytURL: "https://www.youtube.com/watch?v=IkrkF5CY8g8&t=17960s",
  },
  {
    id: 10,
    speaker: "Vivek Kumar Bansal",
    title: "End to End Typing",
    slidesURL:
      "https://docs.google.com/presentation/d/196L7I0ww9BtlJDYpFaqoUoo1eh_lZzbp1AHIvnFgJMU/edit#slide=id.p",
    ytURL: "https://youtu.be/IkrkF5CY8g8?t=19654s",
  },
  {
    id: 11,
    speaker: "Prateek",
    title: "Invincible React States with Domain Driven Design",
    slidesURL:
      "https://www.slideshare.net/Prateekpandey27/invincible-react-states-with-domain-driven-design",
    ytURL: "https://youtu.be/IkrkF5CY8g8?t=23443",
  },
  {
    id: 12,
    speaker: "Prateek Bhatnagar, Pavithra Kodmad, Rahul Dhawani, Ankeet Maini",
    title: "Web Performance",
    slidesURL: "",
    ytURL: "https://youtu.be/IkrkF5CY8g8?t=28803",
  },
];

export const DayTwoData = [
  {
    id: 1,
    speaker: "Pavithra Kodmad",
    title: "Next-gen Frontend tooling",
    slidesURL:
      "https://www.slideshare.net/pksjce/next-generation-frontend-tooling",
    ytURL: "https://youtu.be/HWx6nkLE5Po?t=1015",
  },
  {
    id: 2,
    speaker: "Aditya Agarwal",
    title: "The big problems with Visual Testing",
    slidesURL: "",
    ytURL: "https://youtu.be/HWx6nkLE5Po?t=2597",
  },
  {
    id: 3,
    speaker: "Sreetam Das",
    title: "Building a Green Screen with React and HTML Elements",
    slidesURL: "https://react-greenscreen.netlify.app/",
    ytURL: "https://youtu.be/HWx6nkLE5Po?t=3936",
  },
  {
    id: 4,
    speaker: "Neha Sharma",
    title: "Adding the accessibility in your React Apps",
    slidesURL:
      "https://github.com/Neha/react-day-2021/blob/main/React-day-2021-A11y.pdf",
    ytURL: "https://youtu.be/HWx6nkLE5Po?t=6296",
  },
  {
    id: 5,
    speaker: "Naman Sancheti",
    title: "WebAssembly: Re-defining capabilities of the Web",
    slidesURL: "",
    ytURL: "https://youtu.be/HWx6nkLE5Po?t=8363",
  },
  {
    id: 6,
    speaker: "Tanisha Sabherwal",
    title: "The DEV-inci Code for Design",
    slidesURL:
      "https://docs.google.com/presentation/d/1b67BKmnRhW5JYfgsG8cr37G3sR9PaOZ5TZ6gN6tFPh0/edit#slide=id.p",
    ytURL: "https://youtu.be/HWx6nkLE5Po?t=10228",
  },
  {
    id: 7,
    speaker: "Sooraj Sanker",
    title: "IoT Based Browser Authentication",
    slidesURL: "",
    ytURL: "https://youtu.be/HWx6nkLE5Po?t=10974",
  },
  {
    id: 8,
    speaker: "Sanket Sahu, Aman Mittal, Evan Bacon, Satyajit Sahoo",
    title: "React Native",
    slidesURL: "",
    ytURL: "https://youtu.be/HWx6nkLE5Po?t=14389",
  },
  {
    id: 9,
    speaker: "Muskein Singh",
    title: "Is React Native *truly* Cross Platform",
    slidesURL: "https://slides.com/muskein/deck-ca8860#/1",
    ytURL: "https://youtu.be/HWx6nkLE5Po?t=17113",
  },
  {
    id: 10,
    speaker: "NC Patro",
    title: "Improve React Native performance with Hermes",
    slidesURL: "",
    ytURL: "https://youtu.be/HWx6nkLE5Po?t=18466",
  },
  {
    id: 11,
    speaker: "Sanket Sahu",
    title:
      "Building a universal & accessible component library for the native and the web",
    slidesURL: "",
    ytURL: "https://youtu.be/HWx6nkLE5Po?t=20702",
  },
  {
    id: 12,
    speaker: "Rajat Gupta",
    title: "Optimizing million re-renders in React Native",
    slidesURL: "",
    ytURL: "https://youtu.be/HWx6nkLE5Po?t=22010",
  },
  {
    id: 13,
    speaker: "Kamlesh Chandnani, Vishwa Mehta, Saurabh Daware, Megha Pathak",
    title: "Finding your first job",
    slidesURL: "",
    ytURL: "https://youtu.be/HWx6nkLE5Po?t=26020",
  },
];
